import React from "react";
import "../../styles/ExistingClaimStatus.scss";
import GapButton from "../gap-button/GapButton";
import List from "../list/List";
import ListItem from "../list-item/ListItem";

const ExistingClaimStatus = (props) => {
    const { handleBack, handleNext, claimDetails } = props;

    const getErrorMessage = (item) => {
        const storageData = JSON.parse(localStorage.getItem('tpa_data'));
        if (!storageData?.policy_Types?.includes(item?.contract?.productType.toUpperCase())) {
            const message = "We are unable to process these claim types online. Please call us at " + getPhoneNumber() + " if you need further assistance regarding this claim."
            return message;
        }
        return;
    }

    const getPhoneNumber = () => {
        const data = JSON.parse(localStorage.getItem('tpa_data'));
        if (data?.tel) {
            return formatPhoneNumber(data?.tel);
        }
        return null;
    }

    const formatPhoneNumber = (phoneNumberString) => {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        return cleaned;
    }

    const getFormattedDate = (date) => {
        if (date) {
            var formattedDate = new Date(date);
            return padZeroLeft(formattedDate.getMonth() + 1, 2) + "/" + padZeroLeft(formattedDate.getDate(), 2) + "/" + padZeroLeft(formattedDate.getFullYear(), 2);
        }
        return;
    }

    function padZeroLeft(str, max) {
        str = str.toString();
        return str.length < max ? padZeroLeft("0" + str, max) : str;
    }
    const displayErrorMessage = (message) => {
        return (
            <React.Fragment>
                {message &&
                    <div className="policy-error-message-container mt-20">
                        <i className="fa fa-exclamation-circle polci-expired-icon"></i>
                        <div className="policy-expired-description">
                            {message}
                        </div>
                    </div>
                }
            </React.Fragment>
        )
    }

    const displayData = () => {
        if(claimDetails?.length > 0) {
            return claimDetails?.map((item,i) => {
                var message = getErrorMessage(item);
                return (
                    <div className="card mt-9" key={i}>
                        <div className="card-container">
                        <div className="d-flex align-items-center justify-content-between mt-9">
                                <div className="d-flex align-items-center">
                                    <i className="fas fa-file-contract card-title__icon" />
                                    <div className="card-title">Claim Information</div>
                                </div>
                                <GapButton
                                    buttonType="button"
                                    id={`claim-status-drawer-submit-button-${i}`}
                                    buttonLabel="View"
                                    buttonClass={message ? "next-btn next-btn--disabled cursor-pointer" : "next-btn cursor-pointer"}
                                    disabled={message ? true : false}
                                    onClick={() => { handleNext(item) }}
                                />
                            </div>
                            <div key={i} className={"d-flex pl-31 flex-wrap flex-row"}>
                                <List>
                                    <div className="card-col__1 mt-9">
                                        <ListItem itemKey="Claim Number" itemValue={item?.claimNumber ?? ""} />
                                    </div>
                                    <div className="d-flex flex-row justify-content-between w-100 mt-11">
                                        <div className="flex-column">
                                            <ListItem itemKey="Policy Type" itemValue={item?.contract?.productType ?? ""} />
                                        </div>
                                        <div className="flex-column status-capitalize">
                                            <ListItem itemKey="Status" itemValue={item?.status ?? ""} />
                                        </div>
                                        <div className="flex-column">
                                            <ListItem itemKey="Date of Loss" itemValue={getFormattedDate(item?.lossDate)} />
                                        </div>
                                    </div>
                                    <div className="card-col__1 mt-9">
                                        <ListItem itemKey="Contract Number" itemValue={item?.contract?.number ?? ""} />
                                    </div>
                                    <div className="card-col__1 mt-9">
                                        <ListItem itemKey="Contract Holder" itemValue={`${item?.contract?.customer?.firstName ?? ""} ${item?.contract?.customer?.lastName ?? ""} ${item?.contract?.customer?.name ?? ""}`} />
                                    </div>
                                    <div className="card-col__1 mt-9">
                                        <ListItem itemKey="VIN" itemValue={item?.contract?.vin ?? ""} />
                                    </div>
                                </List>
                            </div>
                            {displayErrorMessage(message)}
                        </div>
                    </div>
                )
            })
        }
        return;
    }

    return (
        <React.Fragment>
            <div className="contract-heading">Claims Found</div>
            <div className="mt-5">We found the following claims</div>
            <div className="existing-claim-status-container">
                {/* <div className="card-container">
                    <Card cardTitle="Claim Information" cardIcon="fas fa-file-contract">
                        <div className={"d-flex pl-31 flex-wrap flex-row"}>
                            <List>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Claim Number" itemValue={claimDetails?.claimNumber ?? ""} />
                                </div>
                                <div className="d-flex flex-row justify-content-between w-100 mt-11">
                                    <div className="flex-column">
                                        <ListItem itemKey="Policy Type" itemValue={claimDetails?.contract?.productType ?? ""} />
                                    </div>
                                    <div className="flex-column status-capitalize">
                                        <ListItem itemKey="Status" itemValue={claimDetails?.status ?? ""} />
                                    </div>
                                    <div className="flex-column">
                                        <ListItem itemKey="Date of Loss" itemValue={getFormattedDate()} />
                                    </div>
                                </div>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Contract Number" itemValue={claimDetails?.contract?.number ?? ""} />
                                </div>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Contract Holder" itemValue={`${claimDetails?.contract?.customer?.firstName ?? ""} ${claimDetails?.contract?.customer?.lastName ?? ""} ${claimDetails?.contract?.customer?.name ?? ""}`} />
                                </div>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="VIN" itemValue={claimDetails?.contract?.vin ?? ""} />
                                </div>
                            </List>
                        </div>
                    </Card>
                </div> */}
                {/* {displayErrorMessage()} */}
                {displayData()}
                <div className="mt-20 stepper-btn" id="claimStatusBtn">
                    <GapButton onClick={handleBack} id="claim-status-drawer-back-button" buttonType="button" buttonClass="back-btn cursor-pointer" buttonLabel="Back" />
                    {/* <GapButton
                        buttonType="button"
                        id="claim-status-drawer-submit-button"
                        buttonLabel="View Claim"
                        buttonClass={isButtonDisabled ? "next-btn next-btn--disabled cursor-pointer" : "next-btn cursor-pointer"}
                        disabled={isButtonDisabled}
                        onClick={handleNext}
                    /> */}
                </div>
            </div>
        </React.Fragment>
    )
};

export default ExistingClaimStatus;